import { z } from 'zod';

export const addPlayerSchema = z.object({
	firstName: z.string().min(1, 'First Name is required'),
	lastName: z.string().min(1, 'Last Name is required'),
	email: z.string().min(1, 'Email is required').email(),
	phoneNumber: z.string().min(8, 'Phone number must contain minimum 8 characters.')
});

export type AddPlayerData = z.infer<typeof addPlayerSchema>;
